import React       from 'react';
import moment      from 'moment';
import { version } from 'virtual:build-version';

const buildTimestamp = version;

class Component extends React.Component {
    getDateString = () => {
        const lastUpdateMoment = moment.unix(buildTimestamp / 1000);
        //const formattedDate    = lastUpdateMoment.format('DD.MM.YYYY HH:mm:ss');
        const formattedDate    = lastUpdateMoment.format('YYYY-MM-DD.HHmm');
        return formattedDate;
    };

    render () {
        return (
            <div>
                Build Version: {this.getDateString()}
            </div>
        );
    }
}

Component.propTypes = {};

Component.defaultProps = {};

export default Component;